// Get network from environment variable
// REACT_APP_NETWORK=mainnet or REACT_APP_NETWORK=testnet
const network = process.env.REACT_APP_NETWORK || 'mainnet';
const isTestnet = network === 'testnet';

const config = {
  defaultConnector: 0,
  chainId: isTestnet ? 84532 : 8453, // Base Sepolia: 84532, Base Mainnet: 8453
  rpcUrl: isTestnet ? "https://sepolia.base.org/" : "https://mainnet.base.org/",
  supportedChainIds: isTestnet ? [84532] : [8453],
  unsupportedChainSetup: {},
  network: network,
  isTestnet: isTestnet,
};

export default config;
